import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

export default window.customElements.define(
  'exclusible-cursor',
  class extends CustomElement {
    curernt = ''
    constructor() {
      super()

      this._update = this.update.bind(this)
      this._onCursorEnter = this.onCursorEnter.bind(this)
      this._onCursorLeave = this.onCursorLeave.bind(this)
      this._onMouseMove = this.onMouseMove.bind(this)
      this._onMouseDown = this.onMouseDown.bind(this)
      this._onMouseUp = this.onMouseUp.bind(this)
      this._onTransition = this.onTransition.bind(this)

      this._activeClasses = []
      this._activeClass = ''
    }

    connectedCallback() {
      super.connectedCallback()
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      this.unbindEvents()
    }

    onMediaquery({ matches }) {
      if (matches) {
        this.bindEvents()
      } else {
        this.unbindEvents()
      }
    }

    bindEvents() {
      Emitter.on('update', this._update)
      Emitter.on('cursor:enter', this._onCursorEnter)
      Emitter.on('cursor:leave', this._onCursorLeave)
      Emitter.on('transition:leave', this._onTransition)
      Emitter.on('transition-in:done', this._onTransition)

      window.addEventListener('pointermove', this._onMouseMove)
      window.addEventListener('pointerdown', this._onMouseDown)
      window.addEventListener('pointerup', this._onMouseUp)
    }

    unbindEvents() {
      Emitter.off('update', this._update)
      Emitter.off('cursor:enter', this._onCursorEnter)
      Emitter.off('cursor:leave', this._onCursorLeave)
      Emitter.off('transition:leave', this._onTransition)
      Emitter.off('transition-in:done', this._onTransition)

      window.removeEventListener('pointermove', this._onMouseMove)
      window.removeEventListener('pointerdown', this._onMouseDown)
      window.removeEventListener('pointerup', this._onMouseUp)
    }

    onMouseMove(event) {
      this._x = event.x
      this._y = event.y
    }

    update() {
      this.style.transform = `translate(${this._x}px, ${this._y}px) translateZ(0)`
    }

    onTransition() {
      this.onCursorLeave(this.current)
      this._activeClasses = []
      this._activeClass = null
    }

    onCursorEnter(name) {
      this.current = name
      this._activeClasses.push('is-cursor-' + name)
      this._activeClass = this._activeClasses.length
        ? this._activeClasses[this._activeClasses.length - 1]
        : ''

      this.classList.add(this._activeClass)
    }

    onCursorLeave(name) {
      this.current = ''
      this._activeClasses = this._activeClasses.filter(
        (item) => item !== 'is-cursor-' + name
      )
      this._activeClass = this._activeClasses.length
        ? this._activeClasses[this._activeClasses.length - 1]
        : ''

      this.classList.remove('is-cursor-' + name)
    }

    onMouseDown() {
      this.classList.add('is-down')
    }

    onMouseUp() {
      this.classList.remove('is-down')
    }
  }
)
